import { createContext, useContext, useState, useMemo } from 'react';

import { IUserResourceWithRelations } from '../../server/types/models/IUser';

type UserContextState =
  | [
      IUserResourceWithRelations | undefined,
      React.Dispatch<React.SetStateAction<IUserResourceWithRelations | undefined>>
    ]
  | null;

const userContext = createContext<UserContextState>(null);

export type UserProviderProps = {
  user?: IUserResourceWithRelations;
  children: React.ReactNode;
};

const useUser = () => {
  const context = useContext(userContext);

  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }

  return context;
};

const UserProvider = ({ user: initialUser, children }: UserProviderProps) => {
  const [user, setUser] = useState<IUserResourceWithRelations | undefined>(initialUser);

  const value = useMemo<
    [
      IUserResourceWithRelations | undefined,
      React.Dispatch<React.SetStateAction<IUserResourceWithRelations | undefined>>
    ]
  >(() => [user, setUser], [user]);

  return <userContext.Provider value={value}>{children}</userContext.Provider>;
};

export { UserProvider, useUser };
